import { useState } from "react";
import "./itachiEyePassword.css";

function ItachiEyePassword({ onLoginClick }) {
  const [isActivated, setIsActivated] = useState(false);
  const [isRotating, setIsRotating] = useState(false);

  const handleClick = () => {
    setIsActivated((prev) => !prev);
    setIsRotating(true);

    // 🔑 Toggle password visibility in parent
    if (onLoginClick) {
      onLoginClick();
    }

    // Remove rotate class after animation
    setTimeout(() => setIsRotating(false), 1000);
  };

  return (
    <div className="itachi-eye-container" onClick={handleClick}>
      <div className="itachi-eye">
        <div
          className={`itachi-eye-iris ${isActivated ? "active" : ""} ${
            isRotating ? "rotate-once" : ""
          }`}
        >
          <div className="itachi-eye-pupil"></div>
          <div className="itachi-eye-pupil2"></div>
          <div className="itachi-eye-tomoe1"></div>
          <div className="itachi-eye-tomoe2"></div>
          <div className="itachi-eye-tomoe3"></div>
        </div>
      </div>
    </div>
  );
}

export default ItachiEyePassword;
